import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const DelShiftMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  
  const [shift, setShift] = useState([]);
  const [selectedShift, setSelectedShift] = useState([]);
  const [riderList, setRiderLsit] = useState([]);
    
  const totalCount = shift.length;
  const totalMaxUser = shift.reduce((sum, shift) => sum + Number(shift.maxUser), 0);
  const totalToday = shift.reduce((sum, shift) => sum + Number(shift.today), 0);
  const totalday1 = shift.reduce((sum, shift) => sum + Number(shift.day1), 0);
  const totalday2 = shift.reduce((sum, shift) => sum + Number(shift.day2), 0);
  const totalday3 = shift.reduce((sum, shift) => sum + Number(shift.day3), 0);
  const totalday4 = shift.reduce((sum, shift) => sum + Number(shift.day4), 0);
    
  // Date for Rider List 
  const todayDate = new Date().toISOString().split('T')[0];

  const day1Date = new Date();
  day1Date.setDate(day1Date.getDate() + 1);

  const day2Date = new Date();
  day2Date.setDate(day2Date.getDate() + 2);

  const day3Date = new Date();
  day3Date.setDate(day3Date.getDate() + 3);

  const day4Date = new Date();
  day4Date.setDate(day4Date.getDate() + 4);

  const day1 = day1Date.toISOString().split('T')[0];
  const day2 = day2Date.toISOString().split('T')[0];
  const day3 = day3Date.toISOString().split('T')[0];
  const day4 = day4Date.toISOString().split('T')[0];

  
  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => {
      document.title = "Rider Shift Master";
    }, []); // for Title Set

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {

          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible ) {
              if(addmodalVisible){
                setAddModalVisible(false);
              } else {
                setModalVisible(false);
              }
            
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible]);

    useEffect(() => { 
      const fetchUserList = async () => { 
          try {
            const response = await fetch(`${host_url}/rider_shift_master`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                shiftDetail : '',
              }),
            });
            const data = await response.json();
            setShift(data);
            console.log(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchUserList(); 
    }, []); // Shift List

    

    const handleShiftDetail = (row) => {
      console.log(row);
      setModalVisible(true);
      setSelectedShift(row);
    };

    // Functions for handling the different actions
    const handleUpdateShift = async () => {
      setModalVisible(false);
      const shiftDetail = {
            shiftId: selectedShift.shiftId,
            maxUser: selectedShift.maxUser,
      };
      try {
        const response = await fetch(`${host_url}/rider_shift_master`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
            'userid': localStorage.getItem('userid'),
          },
          body: JSON.stringify({
            type: 'update',
            store: store,
            shiftDetail: shiftDetail,
          }),
        });

        if (response.status === 401) {
          localStorage.clear();
          alert('Your account has been disabled.');
          window.location.href = "/";
          return;
        }
      
        const data = await response.json();
        setShift(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };


    const handleRiderList = async (row, day) => {
            
      const shiftDetail = {
            shiftId: row.shiftId,
            shiftDate: day, 
      };
      try {
        const response = await fetch(`${host_url}/rider_shiftwise`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            store: store,
            shiftDetail: shiftDetail,
          }),
        });
        const data = await response.json();
        setRiderLsit(data);
        console.log(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }

      
    };



    const nextDates = [1,2,3,4].map((i) => {
      const d = new Date();
      d.setDate(d.getDate() + i);

      return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    });


  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Rider Shift Master</b>
              <div onClick={() => setAddModalVisible(true)}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th colSpan='2'>Shift</th>
                <th colSpan='2'>Time Slot</th>  
                <th>Max Rider</th>
                <th>Today</th>
                {nextDates.map((date, index) => (
                  <th key={index}>{date}</th>
                ))}  
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {shift.map((row) => {
                  return (
                    <tr key={row.delId} style={{ lineHeight: '10px' }} >
                      
                      <td colSpan='2' className="cell-left" style={{cursor: 'default'}} ><span style={{ paddingLeft: '10px' }}>{row.shift}</span></td>
                      <td colSpan='2' className="cell-left" style={{cursor: 'default'}} ><span style={{ paddingLeft: '10px' }}>{row.shiftTime}</span></td>
                      <td className="cell-right" onClick={() => handleShiftDetail(row)} ><span style={{ paddingRight: '10px' }}>{row.maxUser}</span></td>
                      <td className="cell-right" onClick={() => handleRiderList(row, todayDate)} > <span style={{ paddingRight: '10px' }}>{row.today}</span></td>
                      <td className="cell-right" onClick={() => handleRiderList(row, day1)} ><span style={{ paddingRight: '10px' }} >{row.day1}</span></td>
                      <td className="cell-right" onClick={() => handleRiderList(row, day2)} ><span style={{ paddingRight: '10px' }}>{row.day2}</span></td>
                      <td className="cell-right" onClick={() => handleRiderList(row, day3)} > <span style={{ paddingRight: '10px' }}>{row.day3}</span></td>
                      <td className="cell-right" onClick={() => handleRiderList(row, day4)} ><span style={{ paddingRight: '10px' }} >{row.day4}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '15px' }}>Total</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '10px' }}>{totalMaxUser}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalToday}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalday1}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '10px' }}>{totalday2}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalday3}</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalday4}</span></th>
              </tr>
            </tfoot>
          </table>
        
         
          {/* Modal for Deliveryman Detail */}
            <Modal isOpen={modalVisible}  className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Rider Shift Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Shift</td>
                        <td className="cell-left">{selectedShift.shift}</td>
                      </tr>
                      <tr>
                        <td className="cell-left">Time</td>
                        <td className="cell-left">{selectedShift.shiftTime}</td>
                      </tr>
                      <tr>
                        <td className="cell-left">Max Rider</td>
                        <td><input type="text" maxLength="6" value={selectedShift.maxUser} onChange={(e) => setSelectedShift({ ...selectedShift, maxUser: e.target.value.replace(/[^0-9]/g, '').slice(0, 6)})} /></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleUpdateShift}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          

          
    </div>
  );
};

export default DelShiftMaster;
